import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/image.png";
import Tilt from "react-parallax-tilt";
function Home2() {
  return (
    <Container fluid className="home-about-section " id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description ">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              A passionate motion graphic designer with a flair for bringing
              ideas to life through captivating visual storytelling. With a keen
              eye for detail and a strong foundation in design principles, I
              specialize in creating dynamic and engaging animations that leave
              a lasting impression. My expertise extends across various
              industries, and I thrive on the challenge of transforming concepts
              into visually stunning motion graphics.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid rounded-5 avatar"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
